// Panels on screen (friends, guild, account, the menus), in the order they
// opened. Esc closes the top one first, so pressing it with the friends list
// open closes the list instead of stacking the main menu on top of it.

type Entry = { el: HTMLElement; close: () => void };

const stack: Entry[] = [];

/** Register a panel that has just opened; `close` must remove it from the page. */
export function pushModal(el: HTMLElement, close: () => void): void {
  removeModal(el);
  stack.push({ el, close });
}

/** Forget a panel (call from its close()). */
export function removeModal(el: HTMLElement): void {
  const i = stack.findIndex((entry) => entry.el === el);
  if (i >= 0) stack.splice(i, 1);
}

/** Close the most recently opened panel still on the page. False if there is none. */
export function closeTopModal(): boolean {
  while (stack.length > 0) {
    const top = stack.pop();
    if (top && top.el.isConnected) {
      top.close();
      return true;
    }
  }
  return false;
}

/** Whether any registered panel is still on the page. */
export function hasOpenModal(): boolean {
  return stack.some((entry) => entry.el.isConnected);
}
